import {
    getFacilities,
    addFacility,
    editFacility,
    deleteFacility,
    changeStatus
} from "./facilities.action";

export {facilitiesReducer} from "./facilities.reducer";
export {watchFacilities} from "./facilities.saga";

export const facilitiesActions = {
    /** Facilities */
    getFacilities,
    addFacility,
    editFacility,
    deleteFacility,
    changeStatus
};
